module.exports = __webpack_public_path__ + "static/media/a1.69324570.jpeg";